import { render } from "./skeleton.vue?vue&type=template&id=08936e43&scoped=true"
import script from "./skeleton.vue?vue&type=script&lang=js"
export * from "./skeleton.vue?vue&type=script&lang=js"

import "./skeleton.vue?vue&type=style&index=0&id=08936e43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08936e43"]])

export default __exports__